import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function BBLWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-277">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-278">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-279">
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-280">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-281">
              <img src="https://cdn.magicpatterns.com/uploads/6EDzpM3zn3uoBZwF6ZL1Gw/BeClinical-Lifestyle-31-4-1.jpg" alt="Be CLINICAL BBL Specialist" className="w-full h-full object-cover" data-id="element-282" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-283">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-284">
              WHY CHOOSE BE CLINICAL FOR YOUR BBL TREATMENTS?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-285"></div>

            <p className="text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-286">
              We invite you to schedule a consultation at Be CLINICAL, where our
              knowledgeable skincare professionals will assess your unique
              concerns and goals. Under the guidance of Dr. Fiona Frie, Medical
              Director, our providers offer personalized recommendations and
              develop a treatment plan that suits your needs. Contact Be
              CLINICAL today to take the first step toward a revitalized and
              youthful complexion.
            </p>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-287">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}